
import store from '../store';
import * as con from "./../../GlobalConstants"

import { getApplicationParameter } from './applicationParameters';


export const getMainAdvisor = (userID) => {

    let userDict = getApplicationParameter(con.SURROGATE_USER_DICT)
    return(userDict[userID][con.PROFILE][con.MAIN_ADVISOR])
}

export const getMainAdvisorName = (userID) => {

    let userDict = getApplicationParameter(con.SURROGATE_USER_DICT)
    let mainAdvisorId = userDict[userID][con.PROFILE][con.MAIN_ADVISOR]
    let advisors = store.getState()[con.REDUCER_ADVISORS][con.REDUCER_ADVISORS]
    
    let name = "Sin Asignar"
    if(mainAdvisorId !== null)
    {
        let mainAdvisor = advisors.find((adv) => `${adv[con.ID]}` === `${mainAdvisorId}`)
        name = mainAdvisor[con.NAME_SHORT]
    }
    
    return(name)
}


